import { isBuiltWithWix } from "@resamare/functions";
import { captureException, extraErrorDataIntegration, init } from "@sentry/react";

type InitSentryParams = {
    dsn: string;
    widgetName: string;
};

export const initSentry = ({ dsn, widgetName }: InitSentryParams) => {
    // Sentry ne fonctionne pas avec Wix et je sais pas pourquoi (peut-être version pas supporté)
    if (isBuiltWithWix()) return;

    init({
        dsn,
        integrations: [extraErrorDataIntegration()],

        ignoreErrors: ["Network Error"],

        // Envoie seulement les erreurs provenant du js du widget
        // sinon sentry recupère toutes les erreurs du site
        beforeSend(event) {
            if (!event.exception?.values) return null;

            const regex = new RegExp(
                `https://webservice\\.lagenza\\.fr/assets/widgets/${widgetName}/(production|staging)/widget-${widgetName}\\.(production|staging)\\.js(\\?\\d+)?$`,
            );

            const allFrames = event.exception.values.flatMap(
                (exception) => exception.stacktrace?.frames || [],
            );
            const isFromMyFile = allFrames.every(
                (frame) => frame.filename && regex.test(frame.filename),
            );

            return isFromMyFile ? event : null;
        },
    });
};

interface ErrorWithContext extends Error {
    context?: Record<string, unknown>;
}

export const logError = (error: Error, errorInfo?: React.ErrorInfo) => {
    captureException(error, {
        extra: {
            componentStack: errorInfo?.componentStack || "",

            context: (error as ErrorWithContext).context || null,
        },
    });
};
